export default __webpack_public_path__ + "static/media/liveFeedTeam.029c536d.png";